// src/providers/Web3Provider.tsx
import { type ReactNode, useState, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { createAppKit } from "@reown/appkit/react";
import { wagmiAdapter, projectId, networks } from "../config/wagmi";
import { soneium } from "@reown/appkit/networks";

// Appkit modal
const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId: projectId || "",
  networks: [...networks],
  defaultNetwork: soneium,
  metadata: {
    name: "Harkan Boxes",
    description: "Harkan Lootbox Experience",
    url:
      typeof window !== "undefined"
        ? window.location.origin
        : "https://harkan.io",
    icons: [],
  },
  enableNetworkSwitch: false,
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
});

export { modal };

const queryClient = new QueryClient();

interface Web3ProviderProps {
  children: ReactNode;
}

export function Web3Provider({ children }: Web3ProviderProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {mounted ? children : null}
      </QueryClientProvider>
    </WagmiProvider>
  );
}
